import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=3d188aa9&scoped=true&"
import script from "./ReviewsList.vue?vue&type=script&lang=js&"
export * from "./ReviewsList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsList.vue?vue&type=style&index=0&id=3d188aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d188aa9",
  null
  
)

export default component.exports